import { SNYK_ANNOTATION_ORG, SNYK_ANNOTATION_TARGETID, SNYK_ANNOTATION_TARGETNAME, SNYK_ANNOTATION_TARGETS, SNYK_ANNOTATION_PROJECTIDS } from "../../config";
export { SnykEntityComponent } from "./SnykEntityComponent";
export { SnykOverview } from "./SnykOverviewComponent";
export const isPluginApplicableToEntity = (entity) => {
    var _a, _b, _c, _d, _e;
    return Boolean((_a = entity.metadata.annotations) === null || _a === void 0 ? void 0 : _a[SNYK_ANNOTATION_ORG]) &&
        (Boolean((_b = entity.metadata.annotations) === null || _b === void 0 ? void 0 : _b[SNYK_ANNOTATION_TARGETNAME]) ||
            Boolean((_c = entity.metadata.annotations) === null || _c === void 0 ? void 0 : _c[SNYK_ANNOTATION_TARGETID]) ||
            Boolean((_d = entity.metadata.annotations) === null || _d === void 0 ? void 0 : _d[SNYK_ANNOTATION_TARGETS]) ||
            Boolean((_e = entity.metadata.annotations) === null || _e === void 0 ? void 0 : _e[SNYK_ANNOTATION_PROJECTIDS]));
};
//# sourceMappingURL=index.js.map